import Backdrop from '@material-ui/core/Backdrop';

import { ModalCustom } from './style';

type ModalProps = {
  children: any;
  open: boolean;
  handleClose: any;
};

const ModalComponent = ({ children, open, handleClose }: ModalProps) => {
  return (
    <ModalCustom
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      {children}
    </ModalCustom>
  );
}

export default ModalComponent;
